export default async function(id){
    try {
        const res = await fetch(`https://back-office-sqbb.fr/wp-json/wp/v2/posts/${id}?_embed=true`)
        return await res.json();
    }catch (err){
        console.error(`ERROR ::: ${err}`)
    }
}